import React from 'react';
import Loadable from 'react-loadable';

// class Loader extends React.Component {
//   render() {
//     return <div />;
//   }
// }
const LoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: 'signIn' */ './SignIn'),
  loading: () => null,
  // timeout: 50000,
});

export default class SignInLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    // this.setState({});
    // this.setState({ load: true });
  }
  render() {
    // if (!this.state.load) {
    //   return null;
    // }
    return <LoadableComponent {...this.props} />;
  }
}
